function IsLoading() {
  return (
    <div className="flex items-center justify-center h-20">
      <div className="w-10 h-10 border-4 border-t-5 border-t-blue-500 border-white rounded-full animate-spin"></div>
    </div>
  );
}

export default IsLoading;
